const baseGameOverContent = {
  type: "",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "gameOver",
    file: {},
    languageId: null,
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createGameOverEntry = (title: string, contentType: string, key: string) => ({
  title,
  content: {
    ...baseGameOverContent,
    type: contentType,
    data: {
      ...baseGameOverContent.data,
      key,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const gameOverEntries = [
  { title: "Game Over Image", contentType: "image", key: "gameOverImage" },
  { title: "Game Over Sound", contentType: "audio", key: "gameOverSound" },
];

const gameOverScreen = gameOverEntries.map(({ title, contentType, key }) =>
  createGameOverEntry(title, contentType, key)
);

export { gameOverScreen };